import { Box } from '@mantine/core';

import { useGetColor } from 'hooks';

import type { IconPropsType } from './types';

export const InfoOutlineIcon = ({
  color,
  size = 24,
  sx,
  ...props
}: IconPropsType) => {
  const iconColor = useGetColor(color);

  return (
    <Box
      component="svg"
      sx={sx}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12 5.25C16.004 5.25 19.25 8.49594 19.25 12.5C19.25 16.504 16.004 19.75 12 19.75C7.99594 19.75 4.75 16.504 4.75 12.5C4.75 8.49593 7.99593 5.25 12 5.25Z"
        stroke={iconColor}
        strokeWidth="1.5"
      />
      <path
        d="M12.1615 15.8334V12.5C12.1615 12.1858 12.1615 12.0286 12.0638 11.931C11.9662 11.8334 11.8091 11.8334 11.4948 11.8334"
        stroke={iconColor}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.9947 9.83337H12.0007"
        stroke={iconColor}
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Box>
  );
};
